<template>
  <div class="context">
    <p class="title">リリース</p>
    <div class="newsArea" v-for="item in news" :key="item.date">
      <p class="item">{{ item.date }}</p>
      <p class="item">
        {{ item.content }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news: [],
    };
  },
  mounted() {
    var now = new Date();
    fetch("../json/news.json" + "?" + now.getTime())
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.news = data;
      });
  },
};
</script>

<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 2%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.newsArea {
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: 1fr;
  padding: 2% 0 0 0;
  column-gap: 4%;
}

.item {
  font-size: 1.4vw;
}
</style>
